export {};

$(document).on('click', '[data-href]', function onClickDataHref(evt) {
    const $target = $(evt.target);
    const $href = $(this);
    const href = $href.data('href');
    const openInNewWindow = $href.data('href-new-window');
    const isInsideAnchor = $target.parentsUntil(this).filter('a').length > 0;
    const isTargetAnchor = $target.is('a');

    if (!isInsideAnchor && !isTargetAnchor) {
        if (openInNewWindow) {
            open(href, '_blank');
        } else {
            document.location.href = href;
        }
    }
});



// WEBPACK FOOTER //
// ./js/main/module/data-href.js